/* * @Author: ligai  */
const lineType = {
  // 采购行启用列表
  listEffective: {
    url: `/purchaser/general/lineType/listEffective/share/component`,
    type: 'post'
  },
  getEffectiveByCode: {
    url: `/purchaser/general/lineType/getEffectiveByCode/share/component`,
    type: 'post'
  },
  // 采购行默认值
  getDefault: {
    url: `/purchaser/lineType/getDefault`,
    type: 'post'
  }
}
export default lineType
